import { render, staticRenderFns } from "./FormBarth.vue?vue&type=template&id=43b8142b&scoped=true"
import script from "./FormBarth.vue?vue&type=script&lang=js"
export * from "./FormBarth.vue?vue&type=script&lang=js"
import style0 from "./FormBarth.vue?vue&type=style&index=0&id=43b8142b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b8142b",
  null
  
)

export default component.exports